import React from 'react';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';
import cn from 'classnames';
import cd from 'debug';
import { floor } from 'lodash';

import { Currency } from 'components';
import globalMessages from 'messages';
import PlaceBet from '../../PlaceBet';

import './totalRow.scss';

const debug = cd('app:betslip:components:TotalRow');
const { getCurrency } = core.utils;

interface OwnProps {
    totalStake: number;
    totalPotentialWin: number;
    betslipBetId: string;
    totalOdd?: number | string | JSX.Element;
    withPlus?: boolean;
    isFreebetSelected?: boolean;
}

const { maxPotentialWin } = getCurrency();

const TotalRow: React.FC<OwnProps> = props => {
    debug('render', props);

    const {
        totalStake,
        totalPotentialWin,
        totalOdd,
        betslipBetId,
        withPlus,
        isFreebetSelected,
    } = props;

    const isExceededLimits = totalPotentialWin > maxPotentialWin;

    return (
        <div styleName="container">
            {totalOdd !== undefined && (
                <div styleName="row">
                    <div styleName="title">
                        <FormattedMessage {...globalMessages.totalOdd} />:
                    </div>
                    <div styleName="value">
                        {withPlus && 'x'}
                        {totalOdd}
                    </div>
                </div>
            )}
            {!isFreebetSelected && (
                <div styleName="row">
                    <div styleName="title">
                        <FormattedMessage {...globalMessages.totalStake} />:
                    </div>
                    <div styleName="value">
                        {floor(totalStake, 2)}
                        <Currency />
                    </div>
                </div>
            )}

            {props.children}

            <div styleName="row total-win">
                <div styleName="title">
                    <FormattedMessage {...globalMessages.totalWin} />:
                </div>
                <div
                    styleName={cn('value', {
                        'is-exceeded': isExceededLimits,
                    })}
                >
                    {isExceededLimits
                        ? maxPotentialWin
                        : floor(totalPotentialWin, 2)}
                    <Currency />
                </div>
            </div>

            <PlaceBet
                isFreebetActive={isFreebetSelected}
                totalStake={totalStake}
                betslipBetId={betslipBetId}
            />
        </div>
    );
};

export default TotalRow;
